import { useState, useEffect, useCallback, ChangeEvent, useRef } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import {
  Paper,
  Grid,
  Box,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Checkbox,
  Toolbar,
  ButtonGroup,
  Button,
} from "@material-ui/core";
import styled from "styled-components";
import { IOrder } from "config/interfaces";
import {
  Tooltip,
  ButtonSubmit,
  ButtonCancel,
  SearchInput,
  Select,
  Loading,
  DialogYesNo,
  DialogMotiveToRenewCredential,
} from "components/shared";
import { OrderDetails } from "components/modals";
import { Icons } from "components/Icons";
import { DateTimePicker } from "components/shared/Form";
import { useOrder, useTable } from "hooks";
import {
  convertDateTimeISOWithTimeZone,
  getOrderStatusDescription,
  convertDate,
  isAfterDate,
  convertDateTimeISOWithTimeZoneEND,
} from "utils";
import DialogColect from "components/modals/OrderDetails/DialogColect/DialogColect";
import { TableTitle } from "./styles";
import { RowNoData, TableDownload } from "components/tables";
import { format, addHours } from "date-fns";
import modulockerIcon from "../../../assets/images/logo.png";
import correiosIcon from "../../../assets/images/correios.svg";
import ifoodIcon from "../../../assets/images/icone-ifood.png";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    menuGrid: {
      display: "flex",
      justifyContent: "space-between",
    },
    dwButtonExcell: {
      alignSelf: "center",
      marginRight: 10,

      height: 40,
      width: 40,
      background: "transparent",

      color: "white",
      border: "none",
      borderRadius: 5,
      cursor: "pointer",
    },
    toolbar: {
      paddingBottom: theme.spacing(2),
      borderRadius: "4px",
      background: "var(--backgroundContent)",
      width: "100%",
      "& .MuiToolbar-regular": {
        padding: 0,
      },
    },
    filterBtn: {
      background: "none",
      marginBottom: 20,
    },
    table: {
      borderRadius: "4px",
      background: "var(--backgroundContent)",
      width: "100%",
    },
    margin: {
      margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
      maxWidth: "calc(100% - 12px)",
    },
    input: {
      "& .MuiInputBase-input": {
        boxShadow: "none",
        fontSize: "1.2rem",
        fontWeight: "500",
        textTransform: "uppercase",
      },
    },
    checkbox: {
      "&.MuiCheckbox-colorSecondary.Mui-checked": {
        color: "var(--orange)",
      },
      "& .MuiSvgIcon-root": {
        width: "1.4rem",
      },
    },
    "@media(max-width: 500px)": {
      menuGrid: {
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap",
      },
    },
  })
);
interface TableProps {
  title?: string;
}

const filters: IOrder.SelectField[] = [
  {
    label: "PERÍODO",
    value: "period",
  },
  {
    label: "STATUS",
    value: "status",
  },
];

const dateOfFilters: IOrder.SelectField[] = [
  {
    label: "ENTREGA",
    value: "DHINICIO",
  },
  {
    label: "RETIRADA",
    value: "DHFIM",
  },
];

interface HeadCell {
  disableSorting?: boolean;
  id: keyof IOrder.Table;
  label: string;
}

const headCells: HeadCell[] = [
  { id: "ICONE", label: "" },
  { id: "IDTRANSACAO", label: "ID" },
  { id: "NMUSUARIO", label: "DESTINATÁRIO" },
  { id: "ENDECOMPL", label: "COMPLEMENTO" },
  { id: "NUMERO", label: "BOX" },
  { id: "DESCRICAO", label: "TAMANHO" },
  { id: "DHINICIO", label: "DATA DA ENTREGA" },
  { id: "DHFIM", label: "DATA DA RETIRADA" },
  { id: "STTRANSACAO", label: "STATUS" },
];

const SelectedItems = styled.span`
  text-transform: uppercase;
  font-weight: 700;
  font-size: 1.2rem;
`;

interface DataState {
  filter: string | null;
  dateFrom: Date;
  dateTo: Date;
  status?: string;
  dateOf?: string;
}

const initialState: DataState = {
  filter: null,
  dateFrom: new Date(),
  dateTo: new Date(),
  status: "0",
  dateOf: "DHINICIO",
};

const messageConfirmOrderText = (
  <>
    <p>
      A porta do box deve estar fechada para confirmar a entrega. Confirmar?
    </p>
  </>
);
const messageConfirmOrdersText = (
  <>
    <p>
      As portas do boxes devem estar fechadas para confirmar a entrega.
      Confirmar?
    </p>
  </>
);
const messageCancelOrderText = (
  <>
    <p>
      A entrega será cancelada e o destinatário não receberá o token de
      retirada.
    </p>
    <p>Deseja realmente cancelar a entrega?</p>
  </>
);
const messageCancelOrdersText = (
  <>
    <p>
      As entregas serão canceladas e os destinatários não receberão os tokens de
      retirada.
    </p>
    <p>Deseja realmente cancelar as entregas?</p>
  </>
);
export default function TableOrders({ title }: TableProps) {
  const [data, setData] = useState(initialState);

  const [rows, setRows] = useState([] as IOrder.Order[]);
  const [search, setSearch] = useState("");
  const [selectedOrder, setSelectedOrder] = useState({} as IOrder.Order);
  const [openDetails, setOpenDetails] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);
  const [openRenew, setOpenRenew] = useState(false);
  const [openColect, setOpenColect] = useState(false);

  const [filterFn, setFilterFn] = useState({
    fn: (items: any) => {
      return items;
    },
  });
  const {
    loading,
    orders,
    setPagination,
    statusOptions,
    loadingUpdate,
    renewCredential,
    getOrdersByFilters,
    getAllOrders,
    selectedRows,
    setSelectedRows,
    updateStatusOrder,
    IDMCM,
  } = useOrder();
  const {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterPagingAndSorting,
    actions,
    setActions,
    allowedActions,
    setPage,
  } = useTable({
    records: rows,
    headCells,
    filterFn,
    config: { checkbox: true, actions: true },
    setPagination,
  });

  let inputSearchRef = useRef<HTMLInputElement | null>(null);

  const classes = useStyles();

  useEffect(() => {
    setRows(orders);
  }, [orders]);

  useEffect(() => {
    const allStatus = selectedRows.map((order) => order.STTRANSACAO);
    const filteredStatus = allStatus.filter(
      (status, i, arr) => arr.indexOf(status) === i
    );
    if (filteredStatus.length > 1 || selectedRows.length > 1) {
      return setActions({ ...actions, isAllow: false });
    }

    return String(filteredStatus[0]) !== "5" &&
      String(filteredStatus[0]) === "8"
      ? setActions(allowedActions.pending)
      : String(filteredStatus[0]) === "0" || String(filteredStatus[0]) === "4"
      ? setActions(allowedActions.renewCredentials)
      : setActions((state) => {
          return {
            ...state,
            isAllow: false,
          };
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRows]);

  useEffect(() => {
    if (!loadingUpdate) {
      handleEndDialogs();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingUpdate]);

  const onClick = useCallback((order: IOrder.Order, open: boolean) => {
    setSelectedOrder(order);
    setOpenDetails(open);
  }, []);

  const endComplement = (adressArray: any) => {
    if (adressArray.length === 0) return "";
    let finalString = "";
    adressArray.forEach((item: any) => {
      if (item.DSCOMPLEMENTO) {
        if (item.VLCOMPLEMENTO) {
          finalString =
            finalString + item.DSCOMPLEMENTO + " " + item.VLCOMPLEMENTO + " | ";
        } else {
          finalString = `${finalString + item.DSCOMPLEMENTO} - | `
          // finalString + item.DSCOMPLEMENTO + " " + "-" + " | ";
        }
      }
    });
    return finalString;
  };

  const filterCorreios = (type: string) => {
    if (type === "correios") {
      setFilterFn({
        fn: (items: any) => {
          return items.filter((x: any) => x.ENTREGADOR === 1);
        },
      });
    }
    if (type === "modulocker") {
      setFilterFn({
        fn: (items: any) => {
          return items.filter((x: any) => x.ENTREGADOR === 0);
        },
      });
    }
    if (type === "ifood") {
      setFilterFn({
        fn: (items: any) => {
          return items.filter((x: any) => x.ENTREGADOR === 2);
        },
      });
    }
    if (type === "limpar") {
      setFilterFn({
        fn: (items: any) => {
          return items;
        },
      });
    }
  };

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setPage(0);
    let target = e.target;
    setSearch(target.value);
    setFilterFn({
      fn: (items: any) => {
        if (target.value === "") return items;
        else
          return items.filter(
            (x: any) =>
              x.NMUSUARIO.toLowerCase().includes(target.value.toLowerCase()) ||
              String(x.IDTRANSACAO)
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              endComplement(x.ENDECOMPL)
                .toLowerCase()
                .includes(target.value.toLowerCase())
          );
      },
    });
  };

  const handleSelect = (
    event: React.ChangeEvent<HTMLInputElement>,
    order: IOrder.Order
  ) => {
    if (event.target.checked) {
      let newSelectedRows = [...selectedRows];
      newSelectedRows.push(order);
      setSelectedRows(newSelectedRows);
    } else {
      const newSelectedRows = selectedRows.filter(
        (element) => element.IDTRANSACAO !== order.IDTRANSACAO
      );
      setSelectedRows(newSelectedRows);
    }
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      return setSelectedRows(rows);
    }
    setSelectedRows([] as Array<IOrder.Order>);
  };

  const isSelected = (transactionId: string) =>
    selectedRows.findIndex(
      (element) => element.IDTRANSACAO === Number(transactionId)
    ) !== -1;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, checked } = event.target;

    setData({ ...data, [name]: value ? value : checked });
  };

  const handleDateChange = (value: any, name: string) => {
    if (name) {
      setData({ ...data, [name]: value });
    }
  };

  const handleFilterClick = () => {
    setPage(0);
    switch (data.filter) {
      case "status":
        return getOrdersByFilters({ STTRANSACAO: String(data.status) });
      case "period":
        let params: IOrder.Params = {};

        if (search) {
          params = {
            NMUSUARIO: search.toLocaleUpperCase(),
          };
        }
        if (data.dateOf === "DHINICIO") {
          // dateOF DHINICIO_BEGIN e DHINICIO_END traz todas transações que estão pendentes
          params = {
            DHINICIO_BEGIN: convertDateTimeISOWithTimeZone(data.dateFrom),
            DHINICIO_END: convertDateTimeISOWithTimeZoneEND(data.dateTo),
          };
        } else if (data.dateOf === "DHFIM") {
          // dateOF DHFIM_BEGIN e DHFIM_END traz todas transações que foram finalizadas neste periodo
          params = {
            DHFIM_BEGIN: convertDateTimeISOWithTimeZone(data.dateFrom),
            DHFIM_END: convertDateTimeISOWithTimeZoneEND(data.dateTo),
          };
        }
        return getOrdersByFilters(params);

      default:
        return;
    }
  };

  const handleCancelFilter = () => {
    setData({ ...data, filter: null });
    setSearch("");
    getAllOrders();
  };

  const handleEndDialogs = () => {
    setSelectedRows([] as Array<IOrder.Order>);
    setSelectedOrder({} as IOrder.Order);
    setData(initialState);
  };

  const handleRenewCredential = async (
    idTransacao: string | number,
    motive: string
  ) => {
    renewCredential({ IDTRANSACAO: idTransacao, OBS: motive });
    setOpenRenew(false);
    handleEndDialogs();
  };

  // Parse selectedRows to 2 digits
  const selectedItems =
    selectedRows.length > 0 ? String(selectedRows.length).padStart(2, "0") : 0;

  return (
    <>
      {IDMCM && (
        <>
          <Paper className={classes.toolbar} elevation={0}>
            <Toolbar>
              <Grid container spacing={2} justifyContent="space-between">
                <Grid item xs={6} md={5}>
                  <SearchInput
                    placeholder="Por ID / DESTINATÁRIO / COMPLEMENTO"
                    ref={inputSearchRef}
                    value={search}
                    onChange={handleSearch}
                  />
                </Grid>
                <Grid item xs={6} md={6} alignItems="flex-end">
                  <Box display="flex" justifyContent="flex-end">
                    {recordsAfterPagingAndSorting().length > 0 && (
                      <TableDownload
                        dataToConvert={orders.sort((a: any, b: any) =>
                          a.NMUSUARIO > b.NMUSUARIO ? 1 : -1
                        )}
                        type="encomendas"
                      />
                    )}
                    <Select
                      label="FILTRO"
                      name="filter"
                      choices={filters}
                      value={data.filter}
                      onChange={handleChange}
                    />
                  </Box>
                </Grid>
                <Grid>
                  <ButtonGroup
                    color="primary"
                    aria-label="outlined primary button group"
                  >
                    <div className={classes.filterBtn}>
                      <Tooltip title="Correios">
                        <Button onClick={() => filterCorreios("correios")}>
                          <img
                            style={{ cursor: "pointer" }}
                            src={correiosIcon}
                            width="22px"
                            alt="Ícone Correios"
                          />
                        </Button>
                      </Tooltip>
                      <Tooltip title="Modulocker">
                        <Button onClick={() => filterCorreios("modulocker")}>
                          <img
                            style={{ cursor: "pointer" }}
                            src={modulockerIcon}
                            width="18px"
                            alt="Ícone Modulocker"
                          />
                        </Button>
                      </Tooltip>
                      <Tooltip title="iFood">
                        <Button onClick={() => filterCorreios("ifood")}>
                          <img
                            style={{ cursor: "pointer" }}
                            src={ifoodIcon}
                            width="18px"
                            alt="Ícone Modulocker"
                          />
                        </Button>
                      </Tooltip>
                      <Tooltip title="Limpar">
                        <Button onClick={() => filterCorreios("limpar")}>
                          <Icons.ClearIcon
                            style={{
                              fontSize: "20px",
                            }}
                          />
                        </Button>
                      </Tooltip>
                    </div>
                  </ButtonGroup>
                </Grid>
              </Grid>
            </Toolbar>

            {data.filter && (
              <Toolbar id="toolbar-period" style={{ marginTop: "16px" }}>
                <Grid container spacing={2} justifyContent="flex-end">
                  <Grid item xs={12} md={6}>
                    <Paper style={{ padding: "16px" }}>
                      {data.filter === "period" && (
                        <Grid container spacing={2} justifyContent="flex-end">
                          <Grid item xs={12} justifyContent="flex-end">
                            <Select
                              label="DATA DE:"
                              name="dateOf"
                              choices={dateOfFilters}
                              value={data.dateOf}
                              onChange={handleChange}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <DateTimePicker
                              label="DE: "
                              name="dateFrom"
                              format="dd/MM/yyyy"
                              value={data.dateFrom}
                              onChange={(e) => handleDateChange(e, "dateFrom")}
                            />
                          </Grid>
                          <Grid item xs={6} justifyContent="flex-end">
                            <DateTimePicker
                              label="ATÉ: "
                              name="dateTo"
                              format="dd/MM/yyyy"
                              value={data.dateTo}
                              minDate={data.dateFrom}
                              minDateMessage={`A data deve ser maior ou igual a ${convertDate(
                                String(data.dateFrom)
                              )}`}
                              onChange={(e) => handleDateChange(e, "dateTo")}
                            />
                          </Grid>
                        </Grid>
                      )}

                      {data.filter === "status" && (
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={4}>
                            <Select
                              label="STATUS"
                              name="status"
                              choices={statusOptions}
                              value={data.status}
                              onChange={handleChange}
                              fullWidth
                            />
                          </Grid>
                        </Grid>
                      )}

                      <Box mt={3} display="flex" justifyContent="flex-end">
                        <ButtonCancel
                          onClick={handleCancelFilter}
                          style={{ marginRight: "16px" }}
                        >
                          LIMPAR
                        </ButtonCancel>
                        <ButtonSubmit
                          autoFocus
                          onClick={handleFilterClick}
                          disabled={isAfterDate(data.dateFrom, data.dateTo)}
                        >
                          FILTRAR
                        </ButtonSubmit>
                      </Box>
                    </Paper>
                  </Grid>
                </Grid>
              </Toolbar>
            )}
          </Paper>

          {!loading ? (
            <Paper className={classes.table} elevation={0}>
              {title && <TableTitle>{title}</TableTitle>}

              <Grid container alignItems="center">
                <Grid item xs={12} sm={6}>
                  <Box display="flex" alignItems="center" minHeight={10}>
                    <SelectedItems>SELECIONADOS: {selectedItems}</SelectedItems>
                    {selectedItems && actions?.isAllow ? (
                      <ul style={{ display: "inline", marginLeft: "8px" }}>
                        {actions.confirm && (
                          <Tooltip title="Confirmar entrega">
                            <IconButton
                              onClick={() => setOpenConfirm(true)}
                              disabled={loadingUpdate}
                            >
                              {" "}
                              <Icons.Activate
                                style={{
                                  fontSize: "20px",
                                  color: "var(--iconGreen)",
                                }}
                              />{" "}
                            </IconButton>
                          </Tooltip>
                        )}

                        {actions.cancel && (
                          <Tooltip title="Cancelar entrega">
                            <IconButton
                              onClick={() => setOpenCancel(true)}
                              disabled={loadingUpdate}
                            >
                              {" "}
                              <Icons.Disable
                                style={{
                                  fontSize: "20px",
                                  color: "var(--red)",
                                }}
                              />{" "}
                            </IconButton>
                          </Tooltip>
                        )}

                        {actions.renewCredential && (
                          <ButtonSubmit
                            onClick={() => setOpenRenew(true)}
                            // disabled={loadingUpdate}
                          >
                            <Icons.Update
                              style={{
                                fontSize: "20px",
                                marginRight: 3,
                                color: "var(--iconGreen)",
                              }}
                            />
                            RENOVAR
                          </ButtonSubmit>
                        )}
                      </ul>
                    ) : null}
                  </Box>
                </Grid>
              </Grid>

              <TblContainer>
                <TblHead
                  numSelected={selectedRows.length}
                  rowCount={rows.length}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {recordsAfterPagingAndSorting().length === 0 ? (
                    <RowNoData />
                  ) : (
                    recordsAfterPagingAndSorting().map(
                      (row: IOrder.Order, index: any) => {
                        const isItemSelected = isSelected(
                          String(row.IDTRANSACAO)
                        );
                        const labelId = `enhanced-table-checkbox-${index}`;

                        return (
                          <TableRow
                            hover
                            key={row.IDTRANSACAO}
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            selected={isItemSelected}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox
                                className={classes.checkbox}
                                checked={isItemSelected}
                                inputProps={{ "aria-labelledby": labelId }}
                                onChange={(
                                  event: React.ChangeEvent<HTMLInputElement>
                                ) => handleSelect(event, row)}
                              />
                            </TableCell>
                            <TableCell>
                              {row.ENTREGADOR === 1 ? (
                                <Tooltip title="Correios">
                                  <img
                                    style={{ cursor: "pointer" }}
                                    src={correiosIcon}
                                    width="25px"
                                    alt="Ícone Correios"
                                  />
                                </Tooltip>
                              ) : (
                                <Tooltip title="Modulocker">
                                  <img
                                    style={{ cursor: "pointer" }}
                                    src={modulockerIcon}
                                    width="20px"
                                    alt="Ícone Modulocker"
                                  />
                                </Tooltip>
                              )}
                            </TableCell>
                            <TableCell align="left">
                              {row.IDTRANSACAO}
                            </TableCell>
                            <TableCell align="left">{row.NMUSUARIO}</TableCell>{" "}
                            <TableCell align="left">
                              {endComplement(row.ENDECOMPL)}
                            </TableCell>
                            <TableCell align="left">{row.NUMERO}</TableCell>
                            <TableCell align="left">{row.DESCRICAO}</TableCell>
                            <TableCell align="left">
                              {!row.DHINICIO || row.DHINICIO.length === 0
                                ? "-"
                                : format(
                                    addHours(new Date(row.DHINICIO), 3),
                                    "dd/MM/yyyy HH:mm:ss"
                                  )}
                            </TableCell>
                            <TableCell align="left">
                              {!row.DHFIM ||
                              row.DHFIM.length === 0 ||
                              row.DHFIM === "0000-00-00T00:00:00.000Z"
                                ? "-"
                                : format(
                                    addHours(new Date(row.DHFIM), 3),
                                    "dd/MM/yyyy HH:mm:ss"
                                  )}
                            </TableCell>
                            <TableCell align="left">
                              {getOrderStatusDescription(row.STTRANSACAO)}
                            </TableCell>
                            <TableCell align="left">
                              <IconButton onClick={() => onClick(row, true)}>
                                <Tooltip title="INFORMAÇÕES">
                                  <Icons.Info fontSize="large" />
                                </Tooltip>
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      }
                    )
                  )}
                </TableBody>
              </TblContainer>

              <TblPagination />
            </Paper>
          ) : (
            <Box mt={15} mb={15}>
              <Loading />
            </Box>
          )}
        </>
      )}

      <DialogYesNo
        title="Confirmar Entrega"
        text={
          selectedRows.length > 1
            ? messageConfirmOrdersText
            : messageConfirmOrderText
        }
        onClose={() => setOpenConfirm(false)}
        onClick={() => {
          updateStatusOrder(selectedRows, 0);
          setOpenConfirm(false);
        }}
        open={openConfirm}
      />

      <DialogYesNo
        title="Cancelar Entrega"
        text={
          selectedRows.length > 1
            ? messageCancelOrdersText
            : messageCancelOrderText
        }
        onClose={() => setOpenCancel(false)}
        onClick={() => {
          updateStatusOrder(selectedRows, 1);
          setOpenCancel(false);
        }}
        open={openCancel}
      />

      <DialogMotiveToRenewCredential
        setOpen={setOpenRenew}
        idTransacao={selectedRows[0]?.IDTRANSACAO}
        addreesse={selectedRows[0]?.NMUSUARIO}
        data={selectedRows[0]}
        onRenew={handleRenewCredential}
        open={openRenew}
      />

      <OrderDetails
        order={selectedOrder}
        open={openDetails}
        setOpen={setOpenDetails}
      />

      <DialogColect
        order={selectedRows[0]}
        title="Coletar Encomenda"
        open={openColect}
        setOpen={setOpenColect}
      />
    </>
  );
}
